import React from 'react';
import Joi from 'joi';

import Progress from '../themed/progress';
import Form from '../common/form';

import * as service from '../../services/divisionService';
import * as toastService from '../../services/toastService';

import * as models from '../../utils/models';
import * as utils from '../../utils/utilities';

import withInspectionTypes from '../hoc/withInspectionTypes';

class EditDivision extends Form {
	state = {
		data: initialData,
		errors: {},
		loading: false,
		progress: 0,
	};

	schema = {
		divisionName: Joi.string().min(5).required().label('Division Name'),
		divisionCode: Joi.string().required().label('Division Code'),
		inspectionType: Joi.array()
			.min(0)
			.items(
				Joi.object({
					id: Joi.string().required(),
					name: Joi.string().required(),
					code: Joi.string().required(),
				})
			)
			.required()
			.label('Inspection Types'),
	};

	componentDidMount() {
		const selectedDivision = this.props.selectedDivision;
		if (!selectedDivision) return;

		this.setState({
			data: {
				divisionName: selectedDivision.divisionName,
				divisionCode: selectedDivision.divisionCode,
				inspectionType: selectedDivision.inspectionType.map(
					utils.transformInspectionType
				),
			},
		});
	}

	postData = async (): Promise<void> => {
		const selectedDivision = this.props.selectedDivision;
		if (!selectedDivision) return;

		await service.updateDivision(
			selectedDivision._id,
			this.state.data,
			this.handleProgressChange
		);
		window.location.reload();
	};

	doSubmit = (): void => {
		toastService.promise(this.postData(), {
			loading: 'Updating Division',
			success: () => 'Division updated',
			error: utils.getErrorMessage,
		});
	};

	render() {
		return (
			<React.Fragment>
				<Progress progress={this.state.progress} />

				<form
					autoComplete="off"
					onSubmit={this.handleSubmit}
					className="p-3 container"
				>
					<h1 className="form-title">Update Division</h1>

					<p className="form-subtitle">
						Modify the details below to update the division info
					</p>

					<div className="container-fluid px-0">
						<div className="row">
							<div className="col">
								{this.renderInput({
									type: 'text',
									name: 'divisionName',
									label: 'Division Name',
									placeholder: 'E.g. Topsides Division',
								})}
							</div>

							<div className="col">
								{this.renderInput({
									type: 'text',
									name: 'divisionCode',
									label: 'Division Code',
									placeholder: 'Enter Division Code',
								})}
							</div>
						</div>

						{this.renderMultiSelect({
							options: this.props.types,
							name: 'inspectionType',
							placeholder: 'Select Inspection Types',
							label: 'Inspection Types',
							showCheckbox: true,
							loading: false,
						})}
					</div>

					<div className="d-flex justify-content-end">
						{this.renderButton(this.state.loading ? 'Updating' : 'Update')}
					</div>
				</form>
			</React.Fragment>
		);
	}
}

const initialData: Omit<models.Division, '_id'> = {
	divisionName: '',
	divisionCode: '',
	inspectionType: [],
};

export default withInspectionTypes(EditDivision);
